import { render } from "./TasksAgreedListView.vue?vue&type=template&id=122162a6"
import script from "./TasksAgreedListView.vue?vue&type=script&lang=js"
export * from "./TasksAgreedListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__